// external
import { Box, LinearProgress } from '@mui/material';
import React, { FC, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useService from '../../hooks/service.hook';
import useSnackbarHelper from '../../hooks/snackbar.hook';
import AuthenticationService from '../../services/authentication.service';
import AppContextService from '../../services/app-context.service';
import { AppContext } from '../../models/user.models';

const SSOPage: FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbarHelper();
  const authenticationService = useService(AuthenticationService);
  const appContextService = useService(AppContextService);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get('sso');

    if (token) {
      authenticationService
        .authorize(token)
        .then((response) => {
          const userData = {
            token,
            firstName: response.data.data.firstName,
            lastName: response.data.data.lastName,
            email: response.data.data.email,
            id: response.data.data.userId,
            role: response.data.data.role,
            expiration: response.data.data.exp,
            profileImage: response.data.data.profileImage,
            measurementSystem: response.data.data.measurementSystem,
          };
          window.localStorage.setItem('user', JSON.stringify(userData));

          appContextService
            .getAppContext()
            .then((contextResponse) => {
              const context: AppContext = contextResponse.data.data;
              window.localStorage.setItem('app_context', JSON.stringify(context));
              navigate('/profile');
            })
            .catch(() => {
              navigate('/profile');
            });
        })
        .catch(() => {
          showSnackbar('Unauthorized', 'error');
          navigate('/login');
        });
    } else {
      showSnackbar('Unauthorized', 'error');
      navigate('/login');
    }
  }, [location.search]);

  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        height: window.innerHeight,
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <h1>Authenticating with services...</h1>
      <Box sx={{ width: '70%', margin: 5 }}>
        <LinearProgress />
        <LinearProgress />
        <LinearProgress />
      </Box>
    </div>
  );
};

export default SSOPage;
